<!--- Formulario frmManageShoppingLocationIndex ---->
<!---
Descripción del componente y comportamiento:
CASO  DE USO:
  * APP07_Gestionar Ubicación Ventas
  * https://grupohispatec.sharepoint.com/:w:/s/Produccin/EclS4s5Oaq1PuUP1WHC5p8cBGanR8-vjjhw25VASNY9mEQ
---------------------------
- Formulario para Gestionar la ubicación de las compras.

Eventos escuchados por el formulario:
-----------------------

Eventos generados por el formulario:
-----------------------
-  XXXXXXX ->
--->

<template>
  <f7-page
    class="main-frmManageSalesLocationDetails"
  >
    <template #fixed>
      <TheNavbar
        :nav-title=" `${locationSelected.Codigo} - ${locationSelected.Nombre}`"
        :back-btn-enable="true"
        :back-callback="BackToMain"
        :style="appTheme"
      />
    </template>
    <div class="padding-half header">
      <!-- Cabecera -->
      <template v-if="!showPreload && pickingList != null">
        <div class="header__texto margin-top-half">
          <!-- Con documento origen -->
          <template v-if="pickingList.DocumentoOrigen != null">
            <!-- Pedido de venta -->
            <template v-if="pickingList.TipoDocumentoOrigen === 1">
              <span class="header__title">Pedido de Venta:</span>
              <span class="header__texto">
                {{ `${pickingList.DocumentoOrigen.Serie}/${pickingList.DocumentoOrigen.Numero}` }}
              </span>
              <span
                v-if="pickingList.DocumentoOrigen.Cliente != null"
                class="header__texto"
              >
                {{ ` ${pickingList.DocumentoOrigen.Cliente.Sujeto.NombreCompleto}` }}
              </span>
            </template>

            <!-- Parte de producción -->
            <template v-else-if="pickingList.TipoDocumentoOrigen === 2">
              <span class="header__title">Parte de Producción:</span>
              <span class="header__texto">
                {{ `${pickingList.DocumentoOrigen.Serie}/${pickingList.DocumentoOrigen.Numero}` }}
              </span>
            </template>
          </template>

          <!-- Sin documento origen -->
          <template v-else-if="pickingList.TipoDocumentoOrigen === 0">
            <span class="header__title">Lista de Ubicación:</span>
            <span class="header__texto">
              {{ `${pickingList.Serie}/${pickingList.Numero}` }}
            </span>
          </template>
        </div>
      </template>
      <!-- Cabecera picking list sin documento origen -->
    </div>
    <UCPreload :show="showPreload" />
    <!-- Campo de busqueda de Articulos -->
    <div class="input-busqueda">
      <f7-list
        no-hairlines-md
      >
        <f7-list-input
          type="text"
          placeholder="Buscar por artículo"
          clear-button
          :value="localFilterText"
          @input="localFilterText = $event.target.value"
        />
        <div class="container__img">
          <img src="@/static/icons/ic_shape.svg">
        </div>
      </f7-list>
    </div>

    <div
      v-if="!showPreload && pickingList != null && pickingList.hasOwnProperty('Lineas') && pickingList.Lineas != null && pickingList.Lineas.length > 0"
      class=""
    >
      <f7-list
        v-for="(item, i) in locationsArticlesSelectedFiltered == null ? locationsArticlesSelected : locationsArticlesSelectedFiltered"
        :key="item.MercanciaListaDeUbicacionesParaRecoleccion.Articulo.Id ?? i"
        class="list-articles"
        media-list
      >
        <f7-list-item
          :class="[
            {
              'item-selected':
                itemQuantitySelected != null
                && item.MercanciaListaDeUbicacionesParaRecoleccion.Articulo.Id === itemQuantitySelected.MercanciaListaDeUbicacionesParaRecoleccion.Articulo.Id,
            },
            item.MercanciaListaDeUbicacionesParaRecoleccion.hasOwnProperty('CantidadPosicionadaAlmacenDestino')
              && item.MercanciaListaDeUbicacionesParaRecoleccion.hasOwnProperty('Cantidad')
              && item.MercanciaListaDeUbicacionesParaRecoleccion.CantidadPosicionadaAlmacenDestino === item.MercanciaListaDeUbicacionesParaRecoleccion.Cantidad
              ? 'finished-items'
              : 'pending-items',
          ]"
          link="#"
          :subtitle="`
          ${
            item.MercanciaListaDeUbicacionesParaRecoleccion.Articulo != null
              ? item.MercanciaListaDeUbicacionesParaRecoleccion.Articulo.Codigo
              : ''
          }`"
          @click="EventArticleQuantitySelected(item)"
        >
          <template #title>
            <div>
              <span class="titlea">
                {{ item.MercanciaListaDeUbicacionesParaRecoleccion.Articulo != null ? item.MercanciaListaDeUbicacionesParaRecoleccion.Articulo.Nombre : '' }}
              </span>
              <div class="btn-add-info-output-worker">
                <img
                  class="content-list-queue-item__icon"
                  width="20"
                  alt="iconInfo"
                  src="@/static/img/ic_gallery.svg"
                  @click="OpenImagenesEntidad(item)"
                >
              </div>
            </div>
          </template>

          <div class="list-articles__article-id-info">
            <span>
              {{ `${$t('common.stocks')}:` }}
              {{
                item.hasOwnProperty('CantidadDisponibleUbicacion')
                  ? item.CantidadDisponibleUbicacion
                  : 0
              }}
              Unidades
            </span>
          </div>
          <div
            v-if="item.UbicadoEnUbicacionPorDefecto"
            class="list-articles__sobrestock"
          >
            <img
              class="padding-right-half"
              width="20"
              alt="gola"
              src="@/static/icons/ic_warning.svg"
            >
            <span>
              Sobre Stock de mercancía
            </span>
          </div>

          <template #after>
            <div>
              {{
                item.MercanciaListaDeUbicacionesParaRecoleccion.hasOwnProperty('CantidadPosicionadaAlmacenDestino')
                  ? item.MercanciaListaDeUbicacionesParaRecoleccion.CantidadPosicionadaAlmacenDestino
                  : 0
              }}
              de
              {{
                item.MercanciaListaDeUbicacionesParaRecoleccion.hasOwnProperty('Cantidad')
                  ? item.MercanciaListaDeUbicacionesParaRecoleccion.Cantidad
                  : 0
              }}
            </div>
          </template>
        </f7-list-item>
      </f7-list>
    </div>
    <div class="content-button">
      <f7-button
        class="btn-confirmar"
        fill
        @click="ScanItem()"
      >
        Escanear artículo
      </f7-button>
    </div>

    <UCCodeScanner
      ref="UCCodeScanner"
      :fab-button-show="false"
      :allow-manual-code-entry="true"
      :autofocus-on-input="true"
      @code-reading="CodeScannerReaded"
      @codigo-barras="CodeScannerReaded"
    />

    <!-- POPUPS DEL FORMULARIO -->

    <f7-popup
      class="frmManageSalesLocationDetails-popup frmManageSalesLocationDetails-popup__content--positioning hide-popup-scanner"
      :opened="actionQuantitySelectionPositioningOpened"
      @popup:closed="itemQuantitySelected = null; quantityPositionSelectedArticle = 0; actionQuantitySelectionPositioningOpened = false"
    >
      <f7-page>
        <template #fixed>
          <TheNavbar
            nav-title="Seleccionar artículo"
            :popup-close-btn-enable="true"
            :style="appTheme"
          />
        </template>
        <f7-block v-if="itemQuantitySelected != null">
          <div class="frmManageSalesLocationDetails-popup__content">
            <p class="frmManageSalesLocationDetails-popup__content--labels frmManageSalesLocationDetails-popup__content--labels--select-quantity">
              Ha seleccionado el artículo "{{ `${itemQuantitySelected.MercanciaListaDeUbicacionesParaRecoleccion.Articulo.Codigo} - ${itemQuantitySelected.MercanciaListaDeUbicacionesParaRecoleccion.Articulo.Nombre}` }}" ¿Qué cantidad desea servir?
            </p>

            <div class="content-stepper text-align-center">
              <br>
              <div
                class="stepper stepper-fill stepper-init"
              >
                <f7-stepper
                  fill
                  :value="quantityMaximumItemSelected"
                  :min="1"
                  :max="quantityMaximumItemSelected"
                  @input="quantityPositionSelectedArticle = Number($event.target.value)"
                />
              </div>
            </div>

            <p class="frmManageSalesLocationDetails-popup__content--labels">
              Seleccione la ubicación destino de la mercancía
            </p>
            <UCSearchEntityERP
              placeholder="Ubicación destino"
              search-text="Ubicación destino"
              search-cancellation-text="Búsqueda ubicación cancelada…"
              search-not-found-text="Ubicación no encontrados…"
              :property-entity-shown-input="['Codigo', 'Nombre']"
              :default-value="pickingList.UbicacionParaPreparacion"
              :property-entity-shown-list-title="['Codigo']"
              :property-entity-shown-list-subtitle="['Nombre']"
              :end-point-for-code-search="GetLocationsByCode"
              :min-text-search="3"
              :qr-search-show="true"
              :emit-evet-change-default-value="true"
              :qr-search-params="{
                showInputButton: true,
                fabButtonShow: false,
                allowManualCodeEntry: true,
                autoOpenCamera: false,
                autofocusOnInput: true,
              }"
              @qr-open-search="EventQrOpen"
              @selection="EventSelectedDestinationLocation"
            />
          </div>
          <div class="frmManageSalesLocationDetails-popup__content--buttons">
            <f7-button
              color="gray"
              @click="actionQuantitySelectionPositioningOpened = false"
            >
              {{ $t('common.cancel') }}
            </f7-button>
            <f7-button
              color="green"
              @click="Confirm"
            >
              {{ $t('common.confirm') }}
            </f7-button>
          </div>
        </f7-block>
      </f7-page>
    </f7-popup>

    <f7-popup
      class="frmManageSalesLocationDetails-popup frmManageSalesLocationDetails-popup__content--serial-number"
      :opened="actionSerialNumberSelectionPositioningOpened"
      @popup:closed="itemQuantitySelected = null; actionSerialNumberSelectionPositioningOpened = false"
    >
      <f7-page>
        <template #fixed>
          <TheNavbar
            nav-title="Seleccionar artículo"
            :popup-close-btn-enable="true"
            :style="appTheme"
          />
        </template>
        <f7-block v-if="itemQuantitySelected != null">
          <div class="frmManageSalesLocationDetails-popup__content">
            <p class="frmManageSalesLocationDetails-popup__content--labels frmManageSalesLocationDetails-popup__content--labels--select-quantity">
              Ha seleccionado el artículo
              "{{
                `${itemQuantitySelected.MercanciaListaDeUbicacionesParaRecoleccion.Articulo.Codigo
                } - ${
                  itemQuantitySelected.MercanciaListaDeUbicacionesParaRecoleccion.Articulo.Nombre}`
              }}"
              ¿Qué número de serie desea servir?
            </p>

            <p class="frmManageSalesLocationDetails-popup__content--labels">
              Seleccione el número de serie
            </p>
            <UCSearchEntityERP
              :placeholder="$t('searchEntity.serialNumber.placeholder.serialNumber')"
              :search-text="$t('searchEntity.serialNumber.searchText')"
              :search-cancellation-text="$t('searchEntity.serialNumber.searchCancellationText')"
              :search-not-found-text="$t('searchEntity.serialNumber.searchNotFoundText')"
              :default-etities-list="itemQuantitySelected.AcumuladoExistencias"
              :property-entity-shown-input="['NumeroSerie']"
              :property-entity-shown-list-title="['NumeroSerie']"
              :emit-evet-change-default-value="true"
              @selection="EventSelectedSerialNumber"
            />

            <p class="frmManageSalesLocationDetails-popup__content--labels">
              Seleccione la ubicación destino de la mercancía
            </p>
            <UCSearchEntityERP
              placeholder="Ubicación destino"
              search-text="Ubicación destino"
              search-cancellation-text="Búsqueda ubicación cancelada…"
              search-not-found-text="Ubicación no encontrados…"
              :property-entity-shown-input="['Codigo', 'Nombre']"
              :default-value="pickingList.UbicacionParaPreparacion"
              :property-entity-shown-list-title="['Codigo']"
              :property-entity-shown-list-subtitle="['Nombre']"
              :end-point-for-code-search="GetLocationsByCode"
              :min-text-search="3"
              :qr-search-show="true"
              :emit-evet-change-default-value="true"
              :qr-search-params="{
                showInputButton: true,
                fabButtonShow: false,
                allowManualCodeEntry: true,
                autoOpenCamera: false,
                autofocusOnInput: true,
              }"
              @qr-open-search="EventQrOpen"
              @selection="EventSelectedDestinationLocation"
            />
          </div>
          <div class="frmManageSalesLocationDetails-popup__content--buttons">
            <f7-button
              color="gray"
              @click="actionSerialNumberSelectionPositioningOpened = false"
            >
              {{ $t('common.cancel') }}
            </f7-button>
            <f7-button
              color="green"
              @click="Confirm"
            >
              {{ $t('common.confirm') }}
            </f7-button>
          </div>
        </f7-block>
      </f7-page>
    </f7-popup>

    <f7-popup
      class="frmManageSalesLocationDetails-popup-images"
      :opened="popupImagenes"
      @popup:closed="popupImagenes = false"
    >
      <f7-navbar
        :title="$t('common.files')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link @click="popupImagenes = false">
            <img
              :src="icClose"
              style="padding-right: 10px;"
            >
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <PCImagenesEntidad
        v-if="idEntidad != null"
        :is-active="popupImagenes"
        :entity-id="idEntidad"
        entity-type="Articulo"
        @open-pdf="popupImagenes = false"
      />
    </f7-popup>
  </f7-page>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useAppConfigStore } from '@/js/stores/appConfig';
import { useCommercialisationStore } from '@/js/stores/commercialisation';
import { useParamRef } from '@erpagroapp/params';

import TheNavbar from '@/components/TheNavbar.vue';
import UCPreload from '@/components/common/UCPreload.vue';
import APIErp, { callExecuteSPERP } from '@/js/services/APIErp';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import { HiDialog, HiNotification } from '@/js/common/HINotificationSupport';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import UCCodeScanner from '@/components/common/UCCodeScanner.vue';
import PCImagenesEntidad from '@/components/production/traceability/PCImagenesEntidad.vue';
import icClose from '@/static/icons/ic_close.svg';
import { f7 } from 'framework7-vue';
import { sleep } from '@/js/utils/sleep';

/** @import { ElementoRecoleccionPicking } from '@erpagroapp/types' */

export default {
  name: 'FrmManageSalesLocationDetails',
  components: {
    TheNavbar,
    UCPreload,
    UCSearchEntityERP,
    UCCodeScanner,
    PCImagenesEntidad,
  },
  data() {
    return {
      locationsArticlesSelectedFiltered: null, // Contiene la lista filtrada por el filtro de texto local.
      showPreload: false, // Mostrar preload
      itemQuantitySelected: null, // Artículo con cantidad seleccionado
      actionQuantitySelectionPositioningOpened: false, // actión que permite establecer la cantidad a posicionar
      popupAddNewArticleOpened: false, // actión que permite añadir un nuevo artículo
      quantityPositionSelectedArticle: 0, // Cantidad a posicionar del artículo seleccionado
      actionSerialNumberSelectionPositioningOpened: false, // actión que permite elegir el número de serie a posicionar
      selectedSerialNumber: null, // Número de serie seleccionado cuando se trata de PeticionNumeroSerie
      newLocationSelected: null, // Nueva ubicación donde se posicionan los artículos seleccionados.
      localFilterText: '', // Filtro de texto local
      popupImagenes: false,
      idEntidad: null, // id de la entidad a pasar a PCImagenes entidad
      optionsSelected: false, // Para solo mostrar el Popup o las imagenes
      icClose,
      qrOpen: false,
      disallowLocationAdvancement: useParamRef('NoPermitirAvanzarEnGestionUbicacionesAPP'),
    };
  },
  computed: {
    ...mapState(useAppConfigStore, ['userEnviroment']),

    ...mapState(useCommercialisationStore, [
      'pickingList', // Pickg list seleccionado
      'locationSelected', // Ubicación seleccionada
      'locationsArticlesSelected', // Artículos de la ubicación seleccionada
    ]),

    ...mapWritableState(useCommercialisationStore, [
      'filterText',
      'ResetFrmLocationSales',
    ]),

    // Lista de artículos del locacation list del albaran de compra que NO estan ya en la ubicación seleccionada
    itemProductForNew() {
      if (this.locationsArticlesSelected === null || this.pickingList === null) {
        return [];
      }
      return this.pickingList.Lineas.map(
        (obj) => obj.MercanciaListaDeUbicacionesParaRecoleccion.Articulo,
      ).filter((obj2) => !this.locationsArticlesSelected.some((filtro) => filtro.MercanciaListaDeUbicacionesParaRecoleccion.Articulo.Id === obj2.Id));
    },

    // Cantidad maxima del artículo seleccionado
    quantityMaximumItemSelected() {
      if (this.itemQuantitySelected === null) {
        return 0;
      }
      const cantidadPendiente = Number(this.itemQuantitySelected.MercanciaListaDeUbicacionesParaRecoleccion.Cantidad - this.itemQuantitySelected.MercanciaListaDeUbicacionesParaRecoleccion.CantidadPosicionadaAlmacenDestino) < 0 ? 0 : Number(this.itemQuantitySelected.MercanciaListaDeUbicacionesParaRecoleccion.Cantidad - this.itemQuantitySelected.MercanciaListaDeUbicacionesParaRecoleccion.CantidadPosicionadaAlmacenDestino);
      if (cantidadPendiente > this.itemQuantitySelected.CantidadDisponibleUbicacion) {
        return this.itemQuantitySelected.CantidadDisponibleUbicacion;
      }
      return cantidadPendiente;
    },
    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-slate-blue)',
      };
    },
  },
  watch: {
    localFilterText(newVal) {
      this.FilterData(newVal);
    },
    locationsArticlesSelected() {
      this.FilterData(this.localFilterText);
    },
  },

  created() {
    this.StartComponent();
  },

  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      this.localFilterText = this.filterText;
      this.locationsArticlesSelectedFiltered = this.locationsArticlesSelected;
      this.newLocationSelected = this.pickingList.UbicacionParaPreparacion; // Ubicación definida por defecto.
    },
    BackToMain() {
      f7.views.main.router.back();
    },
    ScanItem() {
      Log(this, this.ScanItem.name);
      this.$refs.UCCodeScanner.Open();
    },

    async Confirm() {
      Log(this, this.Confirm.name);

      if (this.newLocationSelected === null) {
        HiNotification.Alert('Debe seleccionar una ubicación de destino', this.$t('common.warning'));
        return;
      }

      if (this.newLocationSelected.Id === this.locationSelected.Id) {
        HiNotification.Alert('La ubicación de origen no puede ser igual que la ubicación de colocación de la mercacía seleccionada', this.$t('common.warning'));
        return;
      }

      if (this.actionSerialNumberSelectionPositioningOpened && this.selectedSerialNumber === null) {
        HiNotification.Alert('Debe seleccionar un número de serie', this.$t('common.warning'));
        return;
      }

      HiDialog.Preloader(true, 'Actualizando cantidades seleccionadas', false);

      // De las existencias del elemento seleccionado obtenemos la cantidad
      // que se va a posicionar en la ubicación seleccionada
      // generando una lista de ElementoRecoleccionPicking que enviar al backend.
      const listCollectionElement = [];

      const serialNumberRequest = this.itemQuantitySelected.MercanciaListaDeUbicacionesParaRecoleccion.Articulo.PeticionNumeroSerie === true;

      if (!serialNumberRequest) {
        let quantitySelected = 0;

        this.itemQuantitySelected.AcumuladoExistencias.every((objAE) => {
          /** @type {ElementoRecoleccionPicking} */
          const collectionElement = {
            MercanciaListaDeUbicacionesParaRecoleccion: this.itemQuantitySelected.MercanciaListaDeUbicacionesParaRecoleccion,
            Existencia: objAE,
            Cantidad: 0,
            UbicacionDestino: this.newLocationSelected,
          };

          if (objAE.Cantidad >= this.quantityPositionSelectedArticle - quantitySelected) {
            collectionElement.Cantidad = this.quantityPositionSelectedArticle - quantitySelected;
          } else {
            collectionElement.Cantidad = objAE.Cantidad;
          }

          quantitySelected += collectionElement.Cantidad;
          listCollectionElement.push(collectionElement);

          if (quantitySelected >= this.quantityPositionSelectedArticle) {
            return false; // Salimos del bucle
          }

          return true; // Continua el bucle
        });

        this.actionQuantitySelectionPositioningOpened = false;
      } else {
        const selectedElement = this.itemQuantitySelected.AcumuladoExistencias.find(
          (item) => item.NumeroSerie === this.selectedSerialNumber.NumeroSerie,
        );

        if (selectedElement) {
          /** @type {ElementoRecoleccionPicking} */
          const collectionElement = {
            MercanciaListaDeUbicacionesParaRecoleccion: this.itemQuantitySelected.MercanciaListaDeUbicacionesParaRecoleccion,
            Existencia: selectedElement,
            Cantidad: selectedElement.Cantidad,
            UbicacionDestino: this.newLocationSelected,
          };

          listCollectionElement.push(collectionElement);
        }

        this.actionSerialNumberSelectionPositioningOpened = false;
      }

      const result = await this.Conection_UpdateSelectedQuantityArticle(listCollectionElement);
      HiDialog.Preloader(false);

      if (!result.valor) {
        // Mostramos el primer error.
        HiNotification.Toast(result.respuestasValidacion.find((r) => !r.valor).mensaje);
      }

      this.ResetFrmLocationSales = true;
    },

    OpenImagenesEntidad(item) {
      Log(this, this.OpenImagenesEntidad.name);
      this.optionsSelected = true;
      this.idEntidad = item.MercanciaListaDeUbicacionesParaRecoleccion.Articulo.Id;
      this.popupImagenes = true;
    },

    FilterData(val) {
      Log(this, this.FilterData.name);
      this.filterText = val;
      if (this.locationsArticlesSelected == null || val === '') {
        this.locationsArticlesSelectedFiltered = { ...this.locationsArticlesSelected };
        return;
      }
      this.locationsArticlesSelectedFiltered = this.locationsArticlesSelected.filter((item) => item.MercanciaListaDeUbicacionesParaRecoleccion.Articulo.Nombre.toLowerCase().includes(this.localFilterText.toLowerCase()));
    },

    EventArticleQuantitySelected(e, ignoreDisallowParam = false) {
      Log(this, this.EventArticleQuantitySelected.name);

      if (!ignoreDisallowParam && this.disallowLocationAdvancement) {
        return;
      }

      if (e.MercanciaListaDeUbicacionesParaRecoleccion.CantidadPosicionadaAlmacenDestino >= e.MercanciaListaDeUbicacionesParaRecoleccion.Cantidad) {
        HiNotification.Toast('Artículo totalmente ubicado'); // Excepción e2 del CU.
        return;
      }

      if (!this.optionsSelected) {
        this.itemQuantitySelected = e;

        const serialNumberRequest = this.itemQuantitySelected.MercanciaListaDeUbicacionesParaRecoleccion.Articulo.PeticionNumeroSerie === true;

        if (!serialNumberRequest) {
          this.quantityPositionSelectedArticle = this.quantityMaximumItemSelected; // Se inicializa con la máxima cantidad.
          this.actionQuantitySelectionPositioningOpened = true;
        } else {
          this.itemQuantitySelected.AcumuladoExistencias.sort(this.CompareSerialNumbers);
          this.actionSerialNumberSelectionPositioningOpened = true;
        }
      }
      this.optionsSelected = false;
    },

    /**
     * Compare two serial numbers and return a value indicating their order.
     *
     * @param {object} a - The first object with a 'NumeroSerie' property to compare.
     * @param {object} b - The second object with a 'NumeroSerie' property to compare.
     * @returns {number} A negative number if a < b, a positive number if a > b, or 0 if they are equal.
     */
    CompareSerialNumbers(a, b) {
      const serialNumberA = a.NumeroSerie || '0000000000';
      const serialNumberB = b.NumeroSerie || '0000000000';

      return serialNumberA.localeCompare(serialNumberB);
    },

    EventLocationSelected(e) {
      Log(this, this.EventLocationSelected.name);
      if (e !== null) {
        this.$refs.UCCodeScanner.ClosePopup();
      }
      // this.NavigateToLocationDetails(e);
    },

    async EventArticleSelectionForSearch(objArticle) {
      Log(this, this.EventArticleSelectionForSearch.name);

      if (!objArticle) {
        return;
      }

      // El popup de busqueda de ubicaciones tarda en cerrarse, por lo que se espera un poco para que no se cierre antes de que se cierre el popup de lectura de codigo.
      await sleep(200);
      this.$refs.UCCodeScanner.ClosePopup();

      // Buscar si el artículo esta en la lista de locationsArticlesSelected
      const itemFound = this.locationsArticlesSelected.find((e) => e.MercanciaListaDeUbicacionesParaRecoleccion.Articulo.Id === objArticle.Id);
      if (itemFound === undefined) {
        const itemFoundAlternative = this.itemProductForNew.find((e) => e.Id === objArticle.Id);

        if (itemFoundAlternative !== undefined) {
          HiNotification.Alert(
            `El artículo no se encuentra disponible en la ubicación seleccionada ${this.locationSelected.Codigo}-${this.locationSelected.Nombre}. Dispones de existencias en otras ubicaciones. Es necesario ubicarse para hacer el descuento de existencias.`,
            'No es posible seleccionar el articulo.',
          );
          return;
        }

        let entityType;

        if (this.pickingList.TipoDocumentoOrigen === 2) {
          entityType = 'parte de producción';
        } else {
          entityType = 'pedido de venta';
        }

        HiNotification.Alert(
          `El artículo no se encuentra en la lista de artículos del ${entityType} ${this.pickingList.DocumentoOrigen.Serie}/${this.pickingList.DocumentoOrigen.Numero}`,
          'No es posible seleccionar el artículo.',
        );

        return;
      }
      this.EventArticleQuantitySelected(itemFound, true);
    },

    EventSelectedSerialNumber(e) {
      Log(this, this.EventSelectedSerialNumber.name);
      this.selectedSerialNumber = e;
    },

    EventSelectedDestinationLocation(e) {
      Log(this, this.EventSelectedDestinationLocation.name);
      this.newLocationSelected = e;
    },
    EventQrOpen(val) {
      Log(this, this.EventQrOpen.name);
      this.qrOpen = val;
    },

    CodeScannerReaded(barCode) {
      Log(this, this.CodeScannerReaded.name);
      // Buscar en las lineas del pickingList si existe un artículo que en su propiedad CodigosBarras (lista) contenga el codigo de barras leido.
      const itemFound = this.pickingList.Lineas.find((e) => e.MercanciaListaDeUbicacionesParaRecoleccion.Articulo.CodigosBarras.some((e2) => e2.Codigo === barCode));
      if (itemFound !== undefined) {
        this.EventArticleSelectionForSearch(itemFound.MercanciaListaDeUbicacionesParaRecoleccion.Articulo);
      } else {
        let entityType;

        if (this.pickingList.TipoDocumentoOrigen === 2) {
          entityType = 'parte de producción';
        } else {
          entityType = 'pedido de venta';
        }

        HiNotification.Alert(
          `No se ha encontrado ningún artículo con el código de barras leído en la lista de selección de artículos del ${entityType} ${this.pickingList.DocumentoOrigen.Serie}/${this.pickingList.DocumentoOrigen.Numero}`,
          'No es posible añadir el artículo.',
        ); // Excepción e3 del CU.
      }
    },

    /* ObtainLocationsWithSearchCriteria(e) {
      Log(this, this.ObtainLocationsWithSearchCriteria.name);
      return this.GetLocationByFilter(`q:${e}`);
    }, */
    EventConfirmAddNewArticle() {
      Log(this, this.EventConfirmAddNewArticle.name);
      this.popupAddNewArticleOpened = false;
    },

    async Conection_UpdateSelectedQuantityArticle(lstPickingElement) {
      Log(this, this.Conection_UpdateSelectedQuantityArticle.name);
      try {
        const result = await APIErp.callUpdateQuantityPickingList(lstPickingElement);
        if ((result.statusText === 'OK' || result.status === 200) && result.data != null) {
          return result.data;
        }
      } catch (error) {
        HiNotification.Alert('No se ha podido actualizar la cantidad del artículo seleccionado.', 'Error al actualizar la cantidad.');
        LogError(this, this.Conection_UpdateSelectedQuantityArticle.name, error);
      }
      return null;
    },
    /* Ubicaciones */
    GetLocationsByCode(params) {
      Log(this, this.GetLocationsByCode.name);
      if (this.qrOpen) {
        this.qrOpen = false;
        return callExecuteSPERP(
          'APPERPAGRO_UbicacionesXIdGrupoEmpresarial',
          [
            { NombreParametro: 'filtro', Valor: `barcode:${params}` },
            { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
          ],
          'Almacen.UbicacionJSON',
        );
      }
      return callExecuteSPERP(
        'APPERPAGRO_UbicacionesXIdGrupoEmpresarial',
        [
          { NombreParametro: 'filtro', Valor: `q:${params}` },
          { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
        ],
        'Almacen.UbicacionJSON',
      );
    },

    /*     GetLocationByFilter(filter) {
      Log(this, this.GetLocationByFilter.name);
      return callExecuteSPERP('APPERPAGRO_UbicacionesXIdGrupoEmpresarial',
        [{ NombreParametro: 'filtro', Valor: filter },
          { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id }],
        'Almacen.UbicacionJSON');
    }, */
  },
};
</script>

<style lang="scss">
.main-frmManageSalesLocationDetails {
  .input-busqueda {
    background: #fff;

    .list {
      display: flex;
      width: 100%;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;

      ul {
        min-width: 90vw;
      }

      .item-content {
        .item-inner {
          display: flex;
          flex-direction: row;
          align-items: center;
        }
      }
    }

    .container__img {
      display: flex;
      width: 10vw;
      height: 5vh;
      flex-direction: row;
      align-content: center;
      align-items: center;

      img {
        height: 16px;
        width: 16px;
      }
    }
  }

  .disabled {
    opacity: 0.6;
    pointer-events: none;
  }

  .header {
    background: var(--his-oliva);

    span {
      color: #fff;
    }

    &__title {
      margin-left: 8px;
      font-size: 12px;
      opacity: 0.8;
    }

    &__texto {
      font-size: 14px;
    }
  }

  .list-articles {
    --f7-list-item-title-text-color: var(--his-dark-blue);
    --f7-list-item-title-font-size: 16px;
    --f7-list-item-title-font-weight: 600;
    --f7-list-item-after-font-size: 11px;
    --f7-list-item-after-text-color: #ba5333;
    --f7-list-item-after-font-weight: 500;
    --f7-list-item-subtitle-font-size: 11px;
    --f7-list-item-subtitle-line-height: 1.8;
    --f7-list-item-subtitle-text-color: var(--his-oliva);

    li {
      &.pending-items .item-after {
        color: #ba5333;
        background-color: var(--his-mandarina-tint);
      }

      &.finished-items .item-after {
        background-color: #e5f6d3;
        color: #66ba33;
      }

      .item-content {
        .item-inner {
          font-size: 11px;
          color: var(--his-oliva);

          .item-title-row {
            display: flex;
            align-items: center;

            .item-after {
              padding: 4px 8px;
              border-radius: 3px;
            }
          }
        }
      }
    }

    .item-selected {
      background-color: #d8d8d8;
    }

    &__article-id-info {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .btn-add-info-output-worker {
        padding-right: 40px;
      }
    }

    &__sobrestock {
      color: var(--his-tomate-dark);
    }

    .item-title {
      div {
        display: flex;
        justify-content: flex-end;
        flex-direction: row-reverse;

        .titlea {
          -webkit-box-orient: vertical;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          margin-top: 2px;
        }

        .btn-add-info-output-worker {
          margin-right: 10px;
        }
      }
    }
  }

  .content-button {
    position: fixed;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    bottom: 0;
    margin-bottom: calc(25px + var(--information-bar-height));

    .button {
      width: 90%;
      --f7-button-pressed-bg-color: var(--his-slate-blue);
      --f7-button-bg-color: var(--his-green);
    }
  }
}

.frmManageSalesLocationDetails-popup {
  position: absolute;

  &__content {
    height: calc(100% - 20px);

    // &--positioning {
    //   height: 55%;
    //   @media only screen and (min-height: 700px) {
    //     top: 120vw;
    //   }
    //   @media only screen and (max-height: 700px) {
    //     top: 80vw;
    //   }
    // }
    // &--serial-number {
    //   height: 63%;
    //   @media only screen and (min-height: 700px) {
    //     top: 110vw;
    //   }
    //   @media only screen and (max-height: 700px) {
    //     top: 68vw;
    //   }
    // }
    &--labels {
      color: var(--his-oliva);
      text-align: center;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;

      &--select-quantity {
        margin: none;
      }
    }

    &--buttons {
      display: flex;
      justify-content: space-between;
      margin-top: 5px;
    }
  }

  .page-content {
    .block {
      height: 90%;

      // .btn-ok-cancel {
      //   position: absolute;
      //   bottom: 20px;
      //   left: 0;
      //   right: 0;
      // }
    }
  }
}

.frmManageSalesLocationDetails-popup-images {
  overflow-y: scroll;
}
</style>
